<mat-icon style="cursor: pointer;" *ngIf="showBackButton" (click)="onBack()">keyboard_backspace</mat-icon>
<nav mat-tab-nav-bar backgroundColor="theme" class="sub-navBar navbar1" *ngIf="vmMachineArr.length > 1"
    [tabPanel]="tabPanel" (selectedIndexChange)="tabChanged($event)" animationDuration="0ms">
    @for (machine of vmMachineArr; track link) {
    <a mat-tab-link (click)="onMachine(machine)"
        [ngClass]="{'activeTab': selectedMachine && selectedMachine.name === machine.name}"
        [active]="machineId == machine.id"> {{machine.name}} </a>
    }
</nav>
<mat-tab-nav-panel #tabPanel>
    <div class="row" style="margin:0px">
        <!-- display as json-->

        <div class="col-sm-6 config-spacing">

            <button class="theme-button" style="margin:10px; margin-left: 20px;"
                matTooltip="After change setting and apply to kiosk" *ngIf="isAdmin" (click)="updateChannelMapping()">
                Apply Changes
            </button>

            <button mat-button [matMenuTriggerFor]="config" *ngIf="_isSuperAdmin"
                style="margin: 10px;">Configuration</button>

            <mat-menu #config="matMenu">
                <button mat-menu-item class="theme-button" matTooltip="Add channel with selection number for vending"
                    *ngIf="(machineType != 'cal8' && isAdmin) || (machineType == 'open' && isAdmin)"
                    (click)="addChannel()">Add channel</button>
                <button mat-menu-item class="theme-button"
                    matTooltip="Create selection with connected machines and auto map with channels number"
                    *ngIf="machineType == 'cal8' || isVendingElement(machineType) && _isSuperAdmin"
                    (click)="createSelection()">Create selection</button>
                <button mat-menu-item class="theme-button" matTooltip="This is for new machines for first time"
                    *ngIf="isVendingElement(machineType) && _isSuperAdmin" (click)="createChannelFromSelection()">Create
                    channel mapping</button>
                <button mat-menu-item class="theme-button" matTooltip="Add cabinet with 8 lockers for CAL8"
                    *ngIf="machineType == 'cal8' && _isSuperAdmin" (click)="addCabinet()">Add
                    Cabinet</button>
                <mat-slide-toggle *ngIf="_isSuperAdmin" (change)="showDeleteButtons($event.source.checked)"
                    style="margin-left: 10px; margin-right: 10px;">Show
                    delete buttons</mat-slide-toggle>
                <button mat-menu-item class="col-md-12" (click)="readVersions()">
                    {{jsdVersion}} -- {{nodeVersion}}
                </button>
            </mat-menu>

            <button mat-button [matMenuTriggerFor]="control" *ngIf="_isSuperAdmin"
                style="padding-left: 10px;">Control</button>

            <mat-menu #control="matMenu">
                <button mat-menu-item matTooltip="Service popup" *ngIf="_isSuperAdmin"
                    (click)="openServiceMenu()"><mat-icon>terminal</mat-icon>Service</button>
                <hr />
                <button mat-menu-item matTooltip="Reset machine" *ngIf="_isSuperAdmin"
                    (click)="resetMachine()"><mat-icon>outbox</mat-icon>Reset machine</button>
                <button mat-menu-item matTooltip="Collect machine" *ngIf="_isSuperAdmin"
                    (click)="collectProductElevetor()"><mat-icon>lock_open</mat-icon>
                    Open hatch</button>
                <button mat-menu-item matTooltip="Reset Solduot" *ngIf="_isSuperAdmin" (click)="resetSoldOut()">
                    <mat-icon>autorenew</mat-icon>
                    Reset sold out</button>
            </mat-menu>





            <!-- <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel> -->


            <app-channel-list [machineType]="machineType" [siteId]="siteId" [systemId]="systemId"
                [machineId]="machineId" [showDeleteButton]="showDeleteButton">
            </app-channel-list>



        </div>

        <div class="col-sm-6 config-spacing">

            <router-outlet></router-outlet>
        </div>

        <!-- <div style="padding-left: 100px;" *ngFor="let machine of vmMachineArr">
        <button class="theme-button" (click)="onMachine(machine)">{{machine.name}}</button>
    </div> -->
    </div>
</mat-tab-nav-panel>